import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { SITE } from "@/site";

const LINKS = [
  { label: "Services", id: "services" },
  { label: "Inclusive", id: "inclusive" },
  { label: "Online", id: "online" },
  { label: "Areas", id: "areas" },
  { label: "FAQ", id: "faq" },
  { label: "Contact", id: "contact" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 border-b transition-colors duration-500 ${
        scrolled ? "glass border-white/10" : "border-transparent"
      }`}
      data-testid="site-nav"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <button onClick={() => go("top")} data-testid="nav-brand" className="flex items-center">
          <img src={SITE.logo} alt="MyPT — My Personal Trainer" className="h-9 md:h-11 w-auto" />
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.id}
              onClick={() => go(l.id)}
              data-testid={`nav-${l.id}`}
              className="font-mono-label text-[11px] text-[#94A3B8] hover:text-[#F8FAFC] transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
          <button
            onClick={() => go("contact")}
            data-testid="nav-cta"
            className="font-mono-label text-[11px] bg-[#FACC15] text-[#020617] px-5 py-2.5 rounded-full font-semibold hover:bg-[#EAB308] transition-colors duration-300"
          >
            Book a session
          </button>
        </nav>

        <button
          onClick={() => setOpen((v) => !v)}
          className="md:hidden text-[#F8FAFC] p-2"
          data-testid="nav-mobile-toggle"
          aria-label="Menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          className="md:hidden glass border-t border-white/10 px-5 py-6 flex flex-col gap-5"
        >
          {LINKS.map((l) => (
            <button
              key={l.id}
              onClick={() => go(l.id)}
              data-testid={`nav-mobile-${l.id}`}
              className="font-display text-2xl text-left text-[#F8FAFC]"
            >
              {l.label}
            </button>
          ))}
        </motion.div>
      )}
    </motion.header>
  );
};
